import { Icon } from './Icon';
import styles from './StatCard.module.css';

export type StatTrend = 'up' | 'down';

export interface StatCardProps {
  label: string;
  /** Pre-formatted for display — amounts carry currency and two decimals. */
  value: string;
  delta?: string;
  trend?: StatTrend;
  className?: string;
}

/** Port of components/data/StatCard.jsx. */
export function StatCard({ label, value, delta, trend = 'up', className }: StatCardProps) {
  return (
    <div className={[styles.card, className].filter(Boolean).join(' ')}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      {delta ? (
        <div className={[styles.delta, trend === 'up' ? styles.up : styles.down].join(' ')}>
          <Icon name={trend === 'up' ? 'arrow-up-right' : 'arrow-down-left'} size={13} />
          {delta}
        </div>
      ) : null}
    </div>
  );
}
